import React, { useState, useRef } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import TextBlock from "components/Shared/TextBlock";
import { MSpinner } from "components/Shared";
import {
  setMultiFactorVerifyCheck
} from "requests/profile";
import { setProfile } from "actions/user";
import MDialog, { ACTION_ADDITIONAL_OPTIONS } from "components/Shared/MDialog.tsx";

const VerifyTwoFactor = (props) => {
  const mounted = useRef(true);
  // Two Factor Code to verify setup
  const [twoFactorCode, setTwoFactorCode] = useState();
  // Response from Verification step
  const [twoFactorVerifyResponse, setTwoFactorVerifyResponse] = useState({ data: { result: { successIndicator: false } }, isFetching: false });
  // User Response Message
  const [responseMessage, setResponseMessage] = useState({ message: "", showErrorDialog: false });
  // Save Two Factor Auth Token
  const [saveClientToken, setSaveClientToken] = useState(false);

  const {
    history,
    multiFactorInitiatedResponse,
    setProfile,
    clearTwoFactorResponse,
    resendCode,
    returnUrl,
    multiFactorRememberThisClientTokenAllowed,
  } = props;

  let multiFactorMethod = "";
  let informationMessage = "";
  let intermediateToken = "";

  if (multiFactorInitiatedResponse) {
    multiFactorMethod = multiFactorInitiatedResponse.data.multiFactorMethod;
    informationMessage = multiFactorInitiatedResponse.data.informationMessage;
    intermediateToken = multiFactorInitiatedResponse.data.intermediateToken;

    // awwwww yea boys why didnt we do this a year ago....
    if (informationMessage.indexOf("123456") >= 0 && twoFactorCode != "123456") setTwoFactorCode("123456");
  }

  let submitMultiFactorVerify = () => {
    setTwoFactorVerifyResponse({ data: { result: { successIndicator: false } }, isFetching: true });
    setMultiFactorVerifyCheck({
      multiFactorMethod: multiFactorMethod,
      verificationCode: twoFactorCode,
      intermediateToken: intermediateToken,
      rememberThisClientIndicator: true,
      returnUrl: returnUrl,
    }, (s) => {
      setTwoFactorVerifyResponse({ data: s, isFetching: false });
      if (s.result.successIndicator) {
        setTimeout(() => verifyResultOnContinue(s), 2000);
      }
      else {
        setResponseMessage({ message: "The verification code entered was invalid. Please try again.", showErrorDialog: true });
      }
    }, () => {
      setTwoFactorVerifyResponse({ data: { result: { successIndicator: false } }, isFetching: false });
      setResponseMessage({ message: "The verification code entered was invalid. Please try again.", showErrorDialog: true });
    }, mounted);
  };

  let verifyResultOnClose = () => {
    setResponseMessage({ message: "", showErrorDialog: false });
    setTwoFactorVerifyResponse({ data: { result: { successIndicator: false } }, isFetching: false });
  };

  let verifyResultOnContinue = (resp) => {
    if (saveClientToken) {
      localStorage.setItem("rememberThisClientToken", resp.result.rememberThisClientToken);
    }
    setProfile(resp);
    if (resp.mustChangePassword) {
      sessionStorage.setItem("MustChangePassword", true);
      history.push("../change-password-required");
    } else {
      history.push("../redirect");
    }
  };

  let TwoFactorCodeKeyDown = (e) => {
    if (e.key == "Enter") {
      e.preventDefault();
      submitMultiFactorVerify();
    }
  };

  let verifyActions = () => {
    let actions = [];
    if (!twoFactorVerifyResponse.isFetching) {
      actions.push({ code: ACTION_ADDITIONAL_OPTIONS, onClick: () => clearTwoFactorResponse(), helpText: "Additional Options" });
    }
    return actions;
  };

  return (
    <>
      <MDialog
        id={"dialog-verify-error"}
        visible={responseMessage.showErrorDialog}
        title={"Verification Error"}
        width={500}>
        <>
          <TextBlock field={responseMessage.message} />
          <hr />
          <div className="verify-controls">
            <Button onClick={() => verifyResultOnClose()}>Continue</Button>
          </div>
        </>
      </MDialog>

      <MDialog
        id={"dialog-verify-error"}
        visible={twoFactorVerifyResponse.data.result.successIndicator}
        title={"Verification Complete"}
        width={400}>
        <div className="two-factor-setup-spinner">
          <TextBlock field={"Logged In. You Will Be Redirected Momentarily..."} />
          <MSpinner />
        </div>
      </MDialog>

      <MDialog
        id={"dialog-verify"}
        visible={!twoFactorVerifyResponse.data.result.successIndicator && !responseMessage.showErrorDialog}
        actions={verifyActions()}
        title={"Please Enter Verification Code"}
        width={500}>
        <>
          {(twoFactorVerifyResponse.isFetching) &&
            <div className="two-factor-setup-spinner">
              <TextBlock field={`Processing...`} />
              <MSpinner />
            </div>}
          {!twoFactorVerifyResponse.isFetching &&
            <>
              <TextBlock field={`${informationMessage}`} />
              <TextField
                variant="standard"
                id="two-factor-code"
                label={"Verification Code"}
                value={twoFactorCode}
                onChange={e => setTwoFactorCode(e.target.value)}
                onKeyDown={e => TwoFactorCodeKeyDown(e)}
                required
              />
              <div className="verify-controls" style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '20px' }}>
                {multiFactorRememberThisClientTokenAllowed &&
                  <FormControlLabel
                    control={
                      <Checkbox
                        value={saveClientToken}
                        onChange={() => setSaveClientToken(!saveClientToken)}
                      />
                    }
                    label="Remember Me On This Computer"
                    disabled={!multiFactorRememberThisClientTokenAllowed}
                  />
                }
                <Button onClick={() => submitMultiFactorVerify()}>Continue</Button>
                <Button sx={{ whiteSpace: 'nowrap' }} onClick={() => resendCode(multiFactorInitiatedResponse.data.multiFactorMethod)}>Re-Send Code</Button>
              </div>
            </>
          }
        </>
      </MDialog>
    </>
  );
};

VerifyTwoFactor.propTypes = {
  history: PropTypes.object,
  multiFactorInitiatedResponse: PropTypes.object,
  setProfile: PropTypes.func,
  clearTwoFactorResponse: PropTypes.func,
  resendCode: PropTypes.func,
  returnUrl: PropTypes.string,
  // SD-14838 multiFactorRememberThisClientTokenAllowed is driven from the authentication webservice by the "User Multi-Factor Remember Me Deny" right
  multiFactorRememberThisClientTokenAllowed: PropTypes.bool,
};

const mstp = state => {
  return {
    returnUrl: state.user.returnUrl
  };
};

const mdtp = dispatch => {
  return {
    setProfile(payload) {
      dispatch(setProfile(payload));
    }
  };
};

export default connect(mstp, mdtp)(VerifyTwoFactor);